import { Card, CardContent, CardHeader, CardTitle } from '@xhubio-saas/core-frontend/ui-components'
import { useTranslation } from 'react-i18next'

/**
 * Public page "Lizenzen und Hinweise" (licenses and notices).
 *
 * Carries the notice DIN asks for in applications of EN 16931 (decision
 * Torsten no. 428). Same route and catalog keys as the Hausverwaltung app
 * (`/licenses`, `legal.licenses.*`), so link, catalog and checks stay alike.
 */
export function LicensesPage() {
  const { t } = useTranslation()

  return (
    <Card className="w-full max-w-3xl mx-auto">
      <CardHeader>
        <CardTitle>{t('legal.licenses.title')}</CardTitle>
      </CardHeader>
      <CardContent className="prose prose-neutral dark:prose-invert max-w-none space-y-6">
        <p>{t('legal.licenses.en16931')}</p>
      </CardContent>
    </Card>
  )
}
